import { useState } from 'react';

import { navigate } from '@xing-com/crate-core-router';
import { XING_JOBS_SEARCH_KI_PATH } from '@xing-com/crate-core-routes';
import { SearchBox } from '@xing-com/crate-jobs-domain-search-components-search-box';
import type { LocationSuggestion } from '@xing-com/crate-jobs-hooks';

export const DirectorySearchBox: React.FC = () => {
  const [keywords, setKeywords] = useState('');
  const [location, setLocation] = useState('');
  const [cityId, setCityId] = useState('');

  const onSelectLocation = (item: LocationSuggestion): void => {
    setLocation(item.name);
    setCityId(item.cityId);
  };

  const onSubmit = (): void => {
    const query = new URLSearchParams();

    if (keywords) {
      query.set('keywords', keywords);
    }
    if (location) {
      query.set('location', location);
    }
    if (cityId) {
      query.set('cityId', cityId);
    }
    query.set('sc_o', 'jobs_search_button');

    navigate(`${XING_JOBS_SEARCH_KI_PATH}?${query.toString()}`);
  };

  return (
    <SearchBox
      keywordsInput={keywords}
      locationInput={location}
      onChangeKeywords={setKeywords}
      onSelectKeywords={setKeywords}
      onChangeLocation={setLocation}
      onSelectLocation={onSelectLocation}
      onSubmit={onSubmit}
    />
  );
};
